import MicroFrontend from "src/mf";
const EditShareClassView = (props) => {
  return (
          <MicroFrontend id="MF_Add_Share_Class_Edit" component={"./EditShareClass"} mf="capTable" params={{...props}}/>
  );
};

export default EditShareClassView;
